<template>
  <div class="d-flex flex-column h-100">
    <header class="masthead mb-auto">
      <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
        <div class="container-fluid">
          <a class="navbar-brand" href="/#/">
            <img src="../../assets/img/logo.png" alt="Logo" />
          </a>
          <div class="my-2 my-lg-0">
            <button
              class="btn btn-light btn-sm my-2 my-sm-0"
              @click="gotoLogin()"
            >
              Login
            </button>
          </div>
        </div>
      </nav>
    </header>
    <div class="container-fluid emailMessage align-items-center bg-grey200">
      <h2 class="text-green">
        Please check your inbox and confirm your Email to continue......
      </h2>
    </div>
  </div>
</template>

<style scoped>
.text-green {
  display: flex;
  text-align: center;
  align-items: center;
}

.emailMessage {
  display: flex;
  text-align: center;
  margin: auto;
  align-items: center;
  min-height: 150vh;
}
</style>

<script>
export default {
  name: "checkemailverify",
  props: ["userid", "password"],
  components: {},
  created() {
    this.$store.commit("showPopup", false);
  },
  methods: {
    gotoLogin() {
      this.$router.push("/login");
    },
    verifyEmail() {
      var dataToSend = {
        id: this.userid,
        password: this.password,
        type: "email",
      };
      this.$store.commit("setLoader", true);
      this.$store
        .dispatch("login", dataToSend)
        .then((res) => {
         
          this.$router.push("/packages");
          clearInterval(this.verifyEmail);
          this.$store.commit("setLoader", false);
          return;
        })
        .catch((err) => {
          this.$store.commit("setLoader", true);
          setTimeout(this.verifyEmail, 50000);
        });
    },
  },

  data() {
    return {};
  },
};
</script>
